<div ngModelGroup="comboMetaAcao-{{data}}" fxFlex="100" fxLayoutGap="20px" fxFlexOffset="20px">
    <combo-pesquisavel #comboMeta
                       nome="metaAcao-{{data}}"
                       [itens]="dados"
                       itemDescricao="descricao"
                       itemId="id"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Descrição Meta"
                       label="Meta"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)">
    </combo-pesquisavel>
</div>
